export const DEFAULT_AUTO_CLOSE_MS = 3000;
export const TYPE_SUCCESS = 'success_notification';
export const TYPE_ERROR = 'error_notification';
export const TYPE_WARNING = 'warning_notification';
